/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesTeamsApplicationTeamsTeamResponse } from '../model/modulesTeamsApplicationTeamsTeamResponse';
import { ModulesTeamsEndpointsContractsTeamsCreateTeamRequest } from '../model/modulesTeamsEndpointsContractsTeamsCreateTeamRequest';
import { ModulesTeamsEndpointsContractsTeamsUpdateTeamRequestModel } from '../model/modulesTeamsEndpointsContractsTeamsUpdateTeamRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { TeamsServiceInterface }                            from './teams.serviceInterface';


@Injectable()
export class TeamsService implements TeamsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a Team.
     * Gets a Team using the Team identifier.
     * @param teamId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeamByIdEndpoint(teamId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesTeamsApplicationTeamsTeamResponse>;
    public getTeamByIdEndpoint(teamId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesTeamsApplicationTeamsTeamResponse>>;
    public getTeamByIdEndpoint(teamId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesTeamsApplicationTeamsTeamResponse>>;
    public getTeamByIdEndpoint(teamId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling getTeamByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesTeamsApplicationTeamsTeamResponse>('get',`${this.basePath}/teams/${encodeURIComponent(String(teamId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Teams.
     * Gets all Teams.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTeamsEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesTeamsApplicationTeamsTeamResponse>>;
    public getTeamsEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesTeamsApplicationTeamsTeamResponse>>>;
    public getTeamsEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesTeamsApplicationTeamsTeamResponse>>>;
    public getTeamsEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesTeamsApplicationTeamsTeamResponse>>('get',`${this.basePath}/teams`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Team.
     * Creates a Team based on the CreateTeamRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teamsPost(body?: ModulesTeamsEndpointsContractsTeamsCreateTeamRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public teamsPost(body?: ModulesTeamsEndpointsContractsTeamsCreateTeamRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public teamsPost(body?: ModulesTeamsEndpointsContractsTeamsCreateTeamRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public teamsPost(body?: ModulesTeamsEndpointsContractsTeamsCreateTeamRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/teams`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Team.
     * Removes a Team using the Team identifier.
     * @param teamId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teamsTeamIdDelete(teamId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public teamsTeamIdDelete(teamId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public teamsTeamIdDelete(teamId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public teamsTeamIdDelete(teamId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling teamsTeamIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/teams/${encodeURIComponent(String(teamId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Team.
     * Updates a Team based on the Team idenfier and UpdateTeamRequest.
     * @param teamId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public teamsTeamIdPut(teamId: string, body?: ModulesTeamsEndpointsContractsTeamsUpdateTeamRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public teamsTeamIdPut(teamId: string, body?: ModulesTeamsEndpointsContractsTeamsUpdateTeamRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public teamsTeamIdPut(teamId: string, body?: ModulesTeamsEndpointsContractsTeamsUpdateTeamRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public teamsTeamIdPut(teamId: string, body?: ModulesTeamsEndpointsContractsTeamsUpdateTeamRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (teamId === null || teamId === undefined) {
            throw new Error('Required parameter teamId was null or undefined when calling teamsTeamIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/teams/${encodeURIComponent(String(teamId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
